import {
    isEmpty as _isEmpty,
    isString as _isString,
    isBoolean as _isBoolean,
    isObject as _isObject,
} from 'lodash';

import {
    ERR_DYNAMIC_VALIDATE_USER_DATA_OPTIONAL,
    ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED,
} from '../../constants/Errors';

const isValidString = (value) => value && _isString(value) && !_isEmpty(value);

const validateUserDataStringProps = (userData) => {
    try {
        const { accountID, parentID, userID, groupID, department, email, firstName, lastName, ipAddress } = userData;

        // accountID (required)
        if (!isValidString(accountID)) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('accountID'));
        }

        // parentID (required)
        if (!isValidString(parentID)) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('parentID'));
        }

        // userID (required)
        if (!isValidString(userID)) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('userID'));
        }

        // groupID (required)
        if (!isValidString(groupID)) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('groupID'));
        }

        // email (required)
        if (!isValidString(email)) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('email'));
        }

        // firstName (required)
        if (!isValidString(firstName)) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('firstName'));
        }

        // lastName (required)
        if (!isValidString(lastName)) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('lastName'));
        }

        // ipAddress (required)
        if (!isValidString(ipAddress)) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('ipAddress'));
        }

        // department (optional)
        if (
            department &&
            (
                !_isString(department) ||
                !_isEmpty(department)
            )
        ) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_OPTIONAL('department'));
        }

        return null;
    } catch (err) {
        return err;
    }
};

const validateUserData = (userData) => {
    try {
        const { permission, plan, customization, items, features, isIntegrationsEnabled } = userData;
        const userDataKeys = Object.keys(userData);

        // permission (required)
        const validPermissions = ['PARENT_ADMIN', 'ADMIN', 'MANAGER', 'BASE_USER'];
        if (
            !permission ||
            !isValidString(permission) ||
            !validPermissions.includes(permission)
        ) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('permission'));
        }

        // plan (required) - sales plans: FREE, PRO, TEAMS do not have access to Pikasso
        const validPlans = ['IC_LEGACY', 'IC_ESSENTIAL', 'IC_POWER', 'IC_ENTERPRISE', 'IC_STARTER', 'IC_BUSINESS', 'IC_SBENTERPRISE'];
        if (
            !plan ||
            !isValidString(plan) ||
            !validPlans.includes(plan)
        ) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('plan'));
        }

        // customization (optional) - IC_LEGACY should not have it or have it with default values
        // TODO: optional, for now we are not checking if the customization properties are valid, but this might be a future improvement
        if (
            customization &&
            !_isObject(customization)
        ) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_OPTIONAL('customization'));
        }

        // items (optional) - IC_LEGACY should not have it or have it with default values
        // TODO: optional, for now we are not checking if the items properties are valid, but this might be a future improvement
        if (
            items &&
            !_isObject(items)
        ) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_OPTIONAL('items'));
        }

        // features (required) - needs core flags for pikasso to load
        const neededFeatureFlags = ['EMAIL_DESIGNER_CORE', 'EMAIL_DESIGNER_LATEST'];
        const featureKeys = Object.keys(features);
        if (
            !features ||
            !_isObject(items) ||
            !neededFeatureFlags.every((key) => featureKeys.includes(key))
        ) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('features'));
        }

        // isIntegrationsEnabled (required)
        if (!userDataKeys.includes('isIntegrationsEnabled') || !_isBoolean(isIntegrationsEnabled)) {
            return new Error(ERR_DYNAMIC_VALIDATE_USER_DATA_REQUIRED('isIntegrationsEnabled'));
        }

        return validateUserDataStringProps(userData);
    } catch (err) {
        return err;
    }
};

export default validateUserData;
